import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";

import { ReactComponent as cluePin } from "../../../assets/images/clue-pin.svg";
import "./PinCluePopup.scss"; // Import the SCSS file

const PinCluePopup = ({
  open,
  onContinue,
  clueData,
  onPinClue,
  IconClass = "clue-icon",
}) => {
  return (
    <Dialog
      open={open}
      // onClose={onClose}
      aria-labelledby="clues-modal-title"
      className="clues-notification"
    >
      {/* Dialog Title */}
      {clueData.message && (
        <DialogTitle id="clues-modal-title" className="clues-dialog__title">
          {/* <img src={hexagon} width={54} height={54} alt="img" /> */}
          {/* <p className="popup-title">{clueData.message}</p> */}
          <p className="clues-dialog__heading">{clueData.message}</p>
        </DialogTitle>
      )}

      {/* Dialog Content */}
      <DialogContent className="clues-dialog__content">
        {clueData.clueItems && clueData.clueItems.length > 0 && (
          <Stack
            direction="row"
            className="clue-items-container"
            justifyContent="center"
            alignSelf="stretch"
            useFlexGap
            gap={4}
          >
            {clueData.clueItems.map((item, index) => (
              <Stack
                key={index}
                direction={`${
                  clueData.clueItems.length > 1 ? "row" : "column"
                }`}
                useFlexGap
                gap={4}
                className="clue-item"
                flex={IconClass === "clue-icon" ? "1 0 0" : null}
                alignItems="center"
              >
                {item.icon && (
                  <img
                    src={item.icon}
                    alt="clue"
                    className={`clues-dialog__${IconClass}`}
                  />
                )}

                {item.description && (
                  <Typography className="clues-dialog__clue-des">
                    {item.description}
                  </Typography>
                )}
              </Stack>
            ))}
          </Stack>
        )}
      </DialogContent>

      {/* Dialog Actions with Buttons */}
      <DialogActions className="clues-dialog__actions">
        <Button
          onClick={onPinClue}
          className="clues-dialog__button clues-dialog__button--ptcb"
        >
          <Stack useFlexGap gap={1} direction="row" alignItems={"center"}>
            <SvgIcon component={cluePin} inheritViewBox />
            Pin to the Clue Board
          </Stack>
        </Button>
        <Button
          onClick={onContinue}
          className="clues-dialog__button clues-dialog__button--continue"
        >
          continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PinCluePopup;
